import { DummyStore } from 'stores';

import { Transaction } from '../types/transaction.type';
import { TxResponse } from '../types/tx-response.type';

export namespace TransactionsStore {
  export const txs = new DummyStore<TxResponse>();
}
